import streamingProviderStore from "./streamingProviderStore";
import { useShallow } from "zustand/react/shallow";

const useStreamingProviderStore = () => {
  const { streamingProvider, setStreamingProvider } = streamingProviderStore(
    useShallow((state) => ({
      streamingProvider: state.streamingProvider,
      setStreamingProvider: state.setStreamingProvider,
    }))
  );

  return { streamingProvider, setStreamingProvider };
};

export default useStreamingProviderStore;

